<div class="print-component">

    <div *ngIf="loadingOutputUrl" class="loader is-active padding-leader-3 padding-trailer-3 color">
        <div class="loader-bars"></div>
        <div class="loader-text"><h3>Generating Map</h3></div>
        <div class="loader-text">
            <p>Your map is being converted to {{ formatDisplay }} and will be available for download when complete.</p>
            <p>You may continue to use other features of this application while the map is being generated.</p>
            <p *ngIf="isReceiveEmailChecked">
                You will recieve an email with a link to the {{ formatDisplay }},
                so you may close this window and continue to use the application or
                click the button below to<br> start over the print setup.<br><br>
                <button class="btn btn-primary" (click)="restart()">Restart Print Setup</button>
            </p>
        </div>
    </div>

    <div *ngIf="outputLoaded" class="output-ready-text">
        <div>
            <i class="icon-ui-check-mark"></i>
            <h3>Your "{{ mapTitle }}" map is complete and ready for printing.</h3>
        </div>
        <button class="btn btn-primary output-button" (click)="openOutput()">Download print-ready {{ formatDisplay }}</button>
        <div *ngIf="isReceiveEmailChecked">
            Or<br>
            <button class="btn btn-primary print-button" (click)="restart()">Go Back</button><br>
            A link to this map was sent to <br><em>{{ user.emailAddress }}</em>
        </div>
    </div>

    <div *ngIf="errorMessage" class="output-ready-text">
        <div>
            <i class="icon-ui-close-circled"></i>
            <h3>Unable To Print Map</h3>
        </div>
        <div>
            {{ errorMessage }}
        </div>
        <button class="btn btn-primary error-reset-button" (click)="restart()">Go Back</button>
    </div>

    <div *ngIf="!loadingOutputUrl && !outputLoaded && !errorMessage" class="container">
        <div class="alert is-active info-div">
            Click on the red printing area outline to modify the print extent.
        </div>
        <!--layout-->
        <label>
            <b>Page Layout</b>
            <select class="select-full" [(ngModel)]="selectedLayout">
                <option *ngFor="let layout of layouts; trackBy:layoutTrack" [ngValue]="layout">{{ layout.name }}</option>
            </select>
        </label>

        <!--map title-->
        <label>
            <b>Map Title</b><i>&nbsp;(optional)</i>
            <input type="text" placeholder="Map Title" [(ngModel)]="mapTitle">
        </label>

        <!--is legend included-->
        <fieldset class="fieldset-checkbox">
            <legend>
                <b>Legend</b>
                <i>&nbsp;(optional)</i>
            </legend>
            <label pointer>
                <input type="checkbox" [checked]="includeLegend" [(ngModel)]="includeLegend">Include legend
            </label>
            <div *ngIf="includeLegend">
                * Note: Toggle layer visibility, reorder and rename layers in the base map legend
            </div>
        </fieldset>

        <!--advanced options-->
        <div class="advanced-options">
            <h4 class="title" pointer (click)="isAdvancedOptionsExpanded = !isAdvancedOptionsExpanded">
                <span class="icon icon-ui-down" *ngIf="isAdvancedOptionsExpanded"></span>
                <span class="icon icon-ui-right" *ngIf="!isAdvancedOptionsExpanded"></span>
                Advanced Options
            </h4>
            <div class="body" *ngIf="isAdvancedOptionsExpanded">

                <!--author-->
                <label>
                    <b>Author</b>
                    <input type="text" placeholder="Author" [(ngModel)]="author">
                </label>

                <!--copyright-->
                <label>
                    <b>Copyright</b>
                    <input type="text" placeholder="Copyright" [(ngModel)]="copyright">
                </label>

                <!--scalebar units-->
                <fieldset class="scalebar-units radio-group">
                    <legend class="radio-group-title">
                        <b>Scalebar Units</b>
                    </legend>
                    <input class="radio-group-input" type="radio" id="miles{{componentId}}"
                           name="scalebarUnits{{componentId}}" [(ngModel)]="scalebarUnits" value="Miles" />
                    <label class="radio-group-label" [for]="'miles' + componentId">Miles</label>

                    <input class="radio-group-input" type="radio" id="feet{{componentId}}"
                           name="scalebarUnits{{componentId}}" [(ngModel)]="scalebarUnits" value="Feet" />
                    <label class="radio-group-label" [for]="'feet' + componentId">Feet</label>
                </fieldset>

                <!--format-->
                <fieldset class="format radio-group">
                    <legend class="radio-group-title">
                        <b>Format</b>
                    </legend>
                    <input class="radio-group-input" type="radio" id="pdf{{componentId}}"
                           name="format{{componentId}}" [(ngModel)]="format" value="pdf" />
                    <label class="radio-group-label" [for]="'pdf' + componentId">PDF</label>

                    <input class="radio-group-input" type="radio" id="png{{componentId}}"
                           name="format{{componentId}}" [(ngModel)]="format" value="png" />
                    <label class="radio-group-label" [for]="'png' + componentId">PNG</label>

                    <input class="radio-group-input" type="radio" id="jpg{{componentId}}"
                           name="format{{componentId}}" [(ngModel)]="format" value="jpg" />
                    <label class="radio-group-label" [for]="'jpg' + componentId">JPG</label>
                </fieldset>

                <!-- Scale drawing layers -->
                <fieldset class="fieldset-checkbox">
                    <label pointer>
                        <input type="checkbox" [(ngModel)]="scaleDrawingLayers">
                        <b>Scale Drawing Layers</b>
                        <i>&nbsp;(Optional)</i>
                    </label>
                </fieldset>

                <!-- Basemap -->
                <fieldset class="scalebar-units radio-group">
                    <legend class="radio-group-title">
                        <b>Basemap</b>
                    </legend>
                    <input class="radio-group-input" type="radio" id="currentBasemap{{componentId}}"
                           name="basemap{{componentId}}" [(ngModel)]="useCurrentBasemap" [value]="true" />
                    <label class="radio-group-label" [for]="'currentBasemap' + componentId">Use current basemap</label>

                    <input class="radio-group-input" type="radio" id="printBasemap{{componentId}}"
                           name="basemap{{componentId}}" [(ngModel)]="useCurrentBasemap" [value]="false" />
                    <label class="radio-group-label" [for]="'printBasemap' + componentId">Use print basemap</label>
                </fieldset>

                <!-- Included Legend Layers -->
                <fieldset class="fieldset-checkbox" *ngIf="includeLegend">
                    <legend>
                        <b>Include Layers in Legend</b>
                    </legend>
                    <label *ngFor="let layer of layers">
                        <ng-container *ngIf="layer.visible && !layer.mapcoreProps.hideInLegend">
                            <input type="checkbox" [checked]="layer.mapcoreProps.showInPrintLegend" (change)="layer.mapcoreProps.showInPrintLegend = !layer.mapcoreProps.showInPrintLegend">
                            {{ layer.mapcoreProps.name || layer.title }}
                        </ng-container>
                    </label>
                </fieldset>

                <!-- Included Routing Layers-->
                <fieldset class="fieldset-checkbox" *ngIf="hasRoutingDetails">
                    <legend>
                        <b>Include Routing Layer Directions</b>
                    </legend>
                    <div *ngIf="format == 'pdf'; else wrongFormat">
                        <label *ngFor="let layer of layers">
                            <ng-container *ngIf="layer.visible && layer.mapcoreProps.routingDetail">
                                <input type="checkbox" [checked]="layer.mapcoreProps.printRoutingDetail" (change)="layer.mapcoreProps.printRoutingDetail = !layer.mapcoreProps.printRoutingDetail">
                                {{ layer.mapcoreProps.name || layer.title }}
                            </ng-container>
                        </label>
                    </div>
                    <ng-template #wrongFormat>
                        <label style="color: darkred">Routing Directions only available with PDF format</label>
                    </ng-template>
                </fieldset>
            </div>
        </div>

        <div class="alert alert-yellow is-active info-div">
            <p>Please be aware that the time it takes for a map to be created is dependent on the size of the template, the number of layers and the amount of data in those layers.</p>
            <p>Larger and more complex maps can take from a few minutes to over an hour to complete. <strong>We recommend selecting the email option below in those cases.</strong></p>
        </div>

        <!--email when done-->
        <fieldset class="fieldset-checkbox">
            <legend>
                <b>Receive Map Link Via Email</b>
                <i>&nbsp;(Optional)</i>
            </legend>
            <label *ngIf="user">
                <input type="checkbox" [(ngModel)]="isReceiveEmailChecked">Yes, email me a link to the map when ready
            </label>
            <span *ngIf="!user">You must be logged in to receive the link via email</span>
        </fieldset>
        <button class="btn btn-fill print-button" (click)="startPrint()">Create print-ready {{ formatDisplay }}</button>
    </div>
</div>
